import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { TitleBar, IconCircle, IconClose, IconCheck } from '../../common/theme';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const ContainerComp = ({pageState, parentState}) =>{
    const [studentData, setStudentData] = useState({});
    const [refreshCompState, setRefreshCompState] = useState(true);    
    const [moduleData, setModuleData] = useState([]);  
    const [hasPretests, setHasPretests] = useState(false);
    const [hasPosttests, setHasPosttests] = useState(false);
    const [hasAssignments, setHasAssignments] = useState(false);

    const componentData = {
        studentData, setStudentData,
        moduleData, setModuleData,
        refreshCompState, setRefreshCompState,
        programList: parentState.programsSelected, setProgramList: parentState.setProgramsSelected,
        setProgramNamesList: parentState.setProgramNamesSelected        
    }; 

    useEffect(() => {   
        if(!parentState.refreshCompState) return;
        
        // find the selected students assignments
        let student = pageState.processedStudentAssignments.find(assignRec=>assignRec.StudentID===parentState.studentSelectedID);
        setStudentData({...student });

        // find the selcted programs assignments
        let programs = student.programs.filter(progRec => parentState.programsSelected.indexOf(progRec.id) > -1);

        // get an array of modules that have been assigned to the program
        let assignedModules = (programs) ? programs.reduce((acc,progRec)=>{
            progRec.assignedModules.map(moduleRec=>{
                acc[moduleRec] = (moduleRec in acc) ? acc[moduleRec]+1 : 1;
            });
            return acc;
        },{}) : {};

        // give students with no assignments full checkmarks for all the modules
        let programsWithNoAssignments = programs.filter((progRec)=>progRec.hasPretest === false && progRec.hasPosttest === false && progRec.hasAssignment === false);
        programsWithNoAssignments.forEach(progRec=>{
            programs[0].modules.forEach(moduleRec=>{
                assignedModules[moduleRec[0]] = (moduleRec[0] in assignedModules) ? assignedModules[moduleRec[0]]+1 : 1;
            });
        });

        let hasPretest = (programs) ? programs.filter((progRec)=>progRec.hasPretest === true).length > 0 : false;
        setHasPretests(hasPretest);
        let hasPosttest = (programs) ? programs.filter((progRec)=>progRec.hasPosttest === true).length > 0 : false;
        setHasPosttests(hasPosttest);
        let hasAssignment = (programs) ? programs.filter((progRec)=>progRec.hasAssignment === true).length > 0 : false;
        setHasAssignments(hasAssignment);

        // calculate which modules the selected program has assigned.      
        let buildModuleData = programs[0].modules.map(moduleRec=>{
            let assignType = (assignedModules[moduleRec[0]]) ? (assignedModules[moduleRec[0]] === programs.length ) ? 'All' : 'Mixed' : 'None';
            return {id:moduleRec[0], name: moduleRec[1], isAssigned: assignType!='None', assignType};
        });

        if(programs.length > 1)
            buildModuleData = [];
        
        setModuleData(buildModuleData);
        
        parentState.setRefreshCompState(false);
    });
    
    return <div><SideModuleTableComp assignments={{hasPretests,hasPosttests,hasAssignments}} pageState={pageState} componentData={componentData} parentState={parentState}/></div>;
};

const SideModuleTableComp = ({pageState, assignments, componentData, parentState}) => {
    const {hasPretests,hasPosttests,hasAssignments} = assignments;
    const [testableProgram,setTestableProgram] = useState(true);

    useEffect(()=>{
        // find the selected student assignments
        let student = pageState.processedStudentAssignments.find(assignRec=>assignRec.StudentID===parentState.studentSelectedID);
        let programs = student.programs.filter(progRec => parentState.programsSelected.indexOf(progRec.id) > -1);
        let hasNoPretest = false;

        programs.forEach(program=>{
            if(program.id==='C4' || program.id==='C5' || program.id==='C6' ||
            program.id==='HLR2P' || program.id==='HLR3' || program.id==='HLR3P' || program.id==='HLR4' || program.id==='HLR4P' ||
            program.id==='LRP' || program.id==='LR1' || program.id==='LR2' || program.id==='LR3' ||
            program.id==='MMM' || program.id.startsWith('QUIZ') || program.id.startsWith('LESSON') || program.id.startsWith('COURSE')
            )
                hasNoPretest = true;
        });
        setTestableProgram(!hasNoPretest);
    });
    const titleRow = <TitleBar>
        <Col  style={{textAlign: 'left'}} xs='8'>Module Name</Col>
        <Col xs='4'>Assigned</Col>
    </TitleBar>;

    const assignButtonClicked = (assign, type) => {
//        console.log('here 2');
        if(componentData.moduleData.length !==0){
            let assignedModules = componentData.moduleData.reduce((acc,e)=>{
                if(e.isAssigned)
                    acc += ';'+e.id; 
                return acc;
            },'').substr(1);
            parentState.setRequestState({programs:parentState.programsSelected, studID:parentState.studentSelectedID, assign, type, assignedModules});
        }
        else
            parentState.setRequestState({programs: parentState.programsSelected, studID:componentData.studentData.StudentID, type:'add', assign:'assignments'});
        componentData.setProgramList([]);
        componentData.setProgramNamesList([]);
    };

    const selectAll=()=>{
        let nextState = [...componentData.moduleData];
        nextState = nextState.map(e=>{e.isAssigned=true;return e;});
        componentData.setModuleData(nextState);
    };

    const unselectAll=()=>{
        let nextState = [...componentData.moduleData];
        nextState = nextState.map(e=>{e.isAssigned=false;return e;});
        componentData.setModuleData(nextState);
    };
    
    const hasModulesChecked=()=>{
        let hasModulesChecked = componentData.moduleData.reduce((acc,e)=>{
            if(e.isAssigned)
                acc=true;
            return acc;
        },false);
        if(componentData.moduleData.length===0)
            return true;
        return hasModulesChecked;
    };

    return (
        <Container>
            <TitleBar>
                <Col  style={{textAlign: 'left'}} xs='8'>Module Name</Col>
                <Col xs='4'>Assigned<br/>
                    <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAll}><IconCheck/></Button>&nbsp;
                    <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={unselectAll}><IconClose/></Button>
                </Col>
            </TitleBar>
                <Row>
                    <Col style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
                        {(componentData.moduleData.length===0) && <Alert variant={'danger'}> Modules cannot be shared across programs.  The selected programs will be saved in their entirety. </Alert>}
                        {componentData.moduleData.map((moduleRec, i) => 
                            <ModuleRow key={i} componentData={componentData} moduleData={moduleRec} />
                        )}
                    </Col>
                </Row>
                <Row style={{marginTop:'10px'}}>
                    <Button variant='success' disabled={!hasModulesChecked()} onClick={()=>assignButtonClicked('assignments','add')}>Save Assignment</Button> 
                </Row>
            <br/>          

        </Container>
    );
};

SideModuleTableComp.propTypes = {
    data: PropTypes.array
};

const CombinedIcon = ({type}) => <>
    {type === 'Mixed' && <IconCircle style={{color: 'green', fontSize: '10px' }}/>}
</>;

const ModuleRow = ({moduleData, componentData}) => {
    let {id, name, isAssigned, assignType} = moduleData;
    const [isChecked,setIsChecked] = useState(false);

    useEffect(()=>{
        setIsChecked(isAssigned);
    },[componentData]);

    const onChangeHandler=(event)=>{

        let nextState = [...componentData.moduleData];
        nextState.find(moduleRec=>moduleRec.id===id).isAssigned = event.target.checked;
        componentData.setModuleData(nextState);

        setIsChecked(event.target.checked);
    };

    return (
        <>
            <Row>
                <Col xs='8'> {name}</Col> 
                {/* <Col style={{textAlign: 'center'}} xs='4'> <CombinedIcon type={assignType}/> <input type="checkbox" onChange={(e)=>onChangeHandler(e)} checked={isChecked}/> </Col> */}
                <Col style={{textAlign: 'center'}} xs='4'> <input type="checkbox" onChange={(e)=>onChangeHandler(e)} checked={isChecked}/> </Col>
                </Row>
        </>
    );
};

export default ContainerComp;